import {
  DateString,
  Integer,
  MpxListResponse,
  PaginationResponse,
  PaginationRequest,
  AgreementShape as CAgreementShape,
  AgreementStatus as CAgreementStatus,
  AgreementType as CAgreementType,
  AgreementAllowedAction as CAgreementAllowedAction,
  AgreementDeclinedItems as CAgreementDeclinedItems,
  UserId,
} from '@cibo/core'

export type AgreementShape = CAgreementShape
export type AgreementStatus = CAgreementStatus
export type AgreementType = CAgreementType
export type AgreementAllowedAction = CAgreementAllowedAction
export type AgreementDeclinedItems = CAgreementDeclinedItems

export interface AgreementNote {
  agreementId: string
  createdDate: string
  enabled: boolean // Not sure what this is
  modifiedDate: string
  note: string
  noteId: number
  userGroup: string // Why is this here?
  userId: UserId
}

export interface AgreementHistory {
  actingUserId: number
  action: 'statusUpdate' | 'create'
  agreementId: string
  agreementType: AgreementType
  createdDate: string
  docPath: string
  modifiedDate: string
  name: string
  status: AgreementStatus
  userId: UserId
}

export interface AgreementItemRequest {
  agreementId: string
  returnStats?: boolean
}
export interface AgreementListRequest extends PaginationRequest<{}> {
  agreementId?: string
  agreementType?: AgreementType
  email?: string // email of the user. WHY IS THIS HERE?
  name?: string
  status?: AgreementStatus
  userId?: UserId
  // orgId?: string // not yet present
}

export interface CreateAgreementRequest {
  name: string
  userId: UserId
  agreementType: AgreementType
  docPath?: string
  metadata?: any
}

export interface AgreementStatusUpdate {
  agreementId: string
  status: string
  note?: string
  agreedIds?: string[]
  declined?: { id: string; reason: string }[]
}

export interface AgreementNoteCreateRequest {
  agreementId: string
  note: string
}

export interface AgreementResponse extends AgreementShape {}
export interface AgreementNotesResponse extends MpxListResponse<AgreementNote> {}
export interface AgreementHistoryResponse extends MpxListResponse<AgreementHistory> {}
export interface AgreementsResponse extends PaginationResponse<AgreementShape> {}

export interface AgreementCreateAttachmentRequest {
  description?: string
  fileId?: string
  fileName?: string
  file: Blob
}

export type AgreementFileResponse = any

export type MimeType = string

export type AgreementAttachmentFile = {
  fileId: string
  fileName?: string
  description?: string
  fileData: {
    bytes: Integer
    contentType: MimeType
    createdDate: DateString
    fileName: string
    modifiedDate: DateString
    uri: string
  }
}

const MAX_FILE_SIZE = (200 * 1024 * 1024) as Integer

export type AttachmentFileDescriptor = {
  description: string
  accept?: string[]
  maxSize?: Integer
}

export const AttachmentFileDescriptors: Partial<Record<
  AgreementType,
  AttachmentFileDescriptor[]
>> = {
  adminReview: [
    {
      description: 'oppSum',
      accept: ['.pdf'],
      maxSize: MAX_FILE_SIZE,
    },
    {
      description: 'shapeFile',
      accept: ['.shp', '.json'],
      maxSize: MAX_FILE_SIZE,
    },
  ],
}
